module.exports = __webpack_public_path__ + "img/stand-up.cee0dfd7.svg";